var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconDisabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/edit (disabled)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HSP-view",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "In-/-Out-tab-Copy-2--LKC-1410",
    transform: "translate(-618.000000, -606.000000)",
    fill: "#DDDDDD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/edit-(disabled)",
    transform: "translate(618.000000, 606.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uE8FE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.712,4.032 L15.888,5.856 L12.144,2.112 L13.968,0.288 C14.160001,0.09599904 14.3959986,0 14.676,0 C14.9560014,0 15.191999,0.09599904 15.384,0.288 L17.712,2.616 C17.904001,2.80800096 18,3.0439986 18,3.324 C18,3.6040014 17.904001,3.83999904 17.712,4.032 Z M0,14.256 L11.064,3.192 L14.808,6.936 L3.744,18 L0,18 L0,14.256 Z",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconDisabled);
export default __webpack_public_path__ + "static/media/edit_icon_disabled.f9c5469c11bd767a5e2ff23b5422a211.svg";
export { ForwardRef as ReactComponent };